import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBolt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M28.5007 14H21.2882L23.9507 5.8875C24.2007 4.9375 23.4819 4 22.5007 4H13.5007C12.7507 4 12.1132 4.55625 12.0132 5.3L10.0132 20.3C9.89441 21.2 10.5944 22 11.5007 22H18.9194L16.0382 34.1562C15.8132 35.1062 16.5382 36 17.4944 36C18.0132 36 18.5194 35.725 18.7944 35.25L29.7944 16.25C30.3757 15.2563 29.6569 14 28.5007 14ZM18.7694 31.3062L20.8632 22.4562L21.4444 19.9937H12.0694L13.9382 6H21.8069L19.3882 13.375L18.5257 16H27.6319L18.7694 31.3062Z" })
});
export default SvgBolt;
